export const posChannel: BroadcastChannel = new BroadcastChannel('pos-sync');
